var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6454 15.25H1.3503C1.15222 15.25 0.996582 15.0943 0.996582 14.8962V2.60115C0.996582 2.40307 1.15222 2.24744 1.3503 2.24744H8.99052C9.30886 2.24744 9.4645 2.62945 9.23812 2.85582L8.54484 3.53496C8.48117 3.59862 8.3892 3.634 8.29724 3.634H2.38314V13.8634H12.6126V7.94931C12.6126 7.85734 12.6479 7.76537 12.7116 7.70171L13.3907 7.00843C13.61 6.78205 13.9991 6.93768 13.9991 7.25603V14.8962C13.9991 15.0943 13.8435 15.25 13.6454 15.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47005 11.3733L4.79547 9.27931C4.80962 9.20857 4.84499 9.13782 4.89451 9.08123L12.6267 1.35611C12.7682 1.21463 12.9875 1.21463 13.129 1.35611L14.8975 3.12468C15.039 3.26617 15.039 3.48547 14.8975 3.62696L7.16536 11.3521C7.11584 11.4016 7.04509 11.437 6.96727 11.4511L4.87329 11.7765C4.63984 11.8119 4.43468 11.6067 4.47005 11.3733ZM6.11129 9.82403L6.05469 10.1919L6.42256 10.1353L13.1856 3.37228L12.8743 3.06102L6.11836 9.82403H6.11129Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboEdit);
export default __webpack_public_path__ + "static/media/FBOEdit.8e0a233c00e351dfeb9e8e8f883562b9.svg";
export { ForwardRef as ReactComponent };